import React from "react";
import { useLocation } from "react-router-dom";
import { getFormattedDate } from "../../../util/dates";
import Container from "../../../ui/Container/Container";
import List from "../../../ui/List/List";
import "./AdminPatientInfo.css";

function AdminPatientInfo() {
  const location = useLocation();
  const patient = location.state.data;
  const patients = location.state.patients;
  const doctor = location.state.doctor;

  function generateQuestionariesData() {
    const data = [
      {
        key: "initial",
        value: "Información inicial",
        navigateTo: "/showResults",
        enabled: true,
        route: {
          patient: patient,
          key: "initial",
          navigateTo: "/adminPatientInfo",
          patientKey: patient.key,
          patients,
          doctor,
        },
      },
      {
        key: "follow",
        value: `Información de seguimiento - ${getFormattedDate(
          new Date(patient.followDate)
        )}`,
        navigateTo: "/showResults",
        enabled: patient.isFollowCompleted,
        route: {
          patient: patient,
          key: "follow",
          navigateTo: "/adminPatientInfo",
          patientKey: patient.key,
          patients,
          doctor,
        },
      },
      {
        key: "final",
        value: `Cuestionario final - ${getFormattedDate(
          new Date(patient.endDate)
        )}`,
        navigateTo: "/showResults",
        enabled: patient.isFinalCompleted,
        route: {
          patient: patient,
          key: "final",
          navigateTo: "/adminPatientInfo",
          patientKey: patient.key,
          patients,
          doctor,
        },
      },
    ];
    return data;
  }

  return (
    <Container
      title={"Información del paciente"}
      backNavigation={"/adminPatientsList"}
      route={{ data: patients, doctor }}
    >
      <span className="patientInfoMain">{`${patient.patientName} : ${patient.key}`}</span>
      <div className="patientInfoList">
        <List data={generateQuestionariesData()} height="80%" />
      </div>
    </Container>
  );
}

export default AdminPatientInfo;
